<template>
  <transition name="fade">
    <b-row
      :class="pageAlertClasses"
      v-show="showAlert"
    >
      <b-col
        cols="10"
        md="11"
      >
        <b class="message">{{ pageAlertInformation.message }}</b>
        <ul>
          <li
            v-for="(alert, index) in pageAlertInformation.alerts"
            :key="index"
          >
            <span>
              {{ alert }}
            </span>
            <span v-if="pageAlertInformation.type !== undefined && pageAlertInformation.type === 'installapp'">
              <a
                href="/"
                @click.stop.prevent="promptInstall"
                class="click-to-install"
              >
                Click to install.
              </a>
            </span>

            <span v-if="pageAlertInformation.type !== undefined && pageAlertInformation.type === 'erroroptions'">
              <a
                href="/"
                @click.stop.prevent="showResendModal"
                class="click-for-support"
              >
                click here for online support.
              </a>
            </span>
          </li>
        </ul>
      </b-col>
      <b-col
        cols="2"
        md="1"
        class="d-flex flex-column justify-content-center"
      >
        <a
          v-if="pageAlertInformation.type !== 'erroroptions'"
          href=""
          @click.stop.prevent="clearPageAlertInformation"
          class="clear-page-alert"
          style="width: 25px;"
        >
          <b-icon-x />
        </a>
      </b-col>
    </b-row>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'pageAlertInformation'
    ]),
    showAlert: function () {
      return this.pageAlertInformation.message.length > 0
    },
    pageAlertClasses () {
      const classes = []
      classes.push('page-alert-container')
      classes.push('page-alert')
      if (this.pageAlertInformation.variant === undefined) {
        classes.push('danger')
      } else {
        classes.push(this.pageAlertInformation.variant)
      }
      return classes
    }
  },
  methods: {
    ...mapActions([
      'clearPageAlertInformation'
    ]),
    ...mapActions({
      setShowResendOptionsPrompt: 'offline/setShowResendOptionsPrompt'
    }),
    showResendModal () {
      this.setShowResendOptionsPrompt(true)
    }
  }
}
</script>

<style scoped lang="scss">
  .message {
    vertical-align: top;
  }

  .click-to-install,
  .clear-page-alert {
    color: #fff;
  }

  .click-for-support {
    color: #333;
  }

  .click-for-support,
  .click-to-install {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  .clear-page-alert {
    display: block;
    text-align: right;
  }
</style>
